var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#EAF3FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.0652 28.815C45.9257 28.6744 45.7598 28.5629 45.577 28.4867C45.3942 28.4105 45.1982 28.3713 45.0002 28.3713C44.8022 28.3713 44.6061 28.4105 44.4233 28.4867C44.2405 28.5629 44.0746 28.6744 43.9352 28.815L32.7602 40.005L28.0652 35.295C27.9204 35.1552 27.7495 35.0452 27.5622 34.9714C27.3749 34.8976 27.1749 34.8614 26.9737 34.8649C26.7724 34.8684 26.5738 34.9115 26.3891 34.9917C26.2045 35.0719 26.0375 35.1878 25.8977 35.3325C25.7578 35.4773 25.6478 35.6482 25.574 35.8355C25.5002 36.0228 25.464 36.2228 25.4675 36.4241C25.471 36.6253 25.5141 36.8239 25.5943 37.0086C25.6746 37.1932 25.7904 37.3602 25.9352 37.5L31.6952 43.26C31.8346 43.4006 32.0005 43.5122 32.1833 43.5884C32.3661 43.6645 32.5622 43.7037 32.7602 43.7037C32.9582 43.7037 33.1542 43.6645 33.337 43.5884C33.5198 43.5122 33.6857 43.4006 33.8252 43.26L46.0652 31.02C46.2174 30.8796 46.3389 30.7091 46.4221 30.5193C46.5052 30.3296 46.5481 30.1247 46.5481 29.9175C46.5481 29.7104 46.5052 29.5055 46.4221 29.3157C46.3389 29.126 46.2174 28.9555 46.0652 28.815Z",
    fill: "#0B71D9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.e2d2695b61408710e4ca6350456755e1.svg";
export { ForwardRef as ReactComponent };